import {metadaApi} from '@dms/api/base';

import {
  PrintOnDemandRequest,
  PrintOnDemandRequestSchema,
  PrintOnDemandResponse,
  PrintOnDemandResponseSchema,
} from './types';

export const metadaWarehousePrintoutOnDemandApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postPrintoutOnDemand: build.mutation<PrintOnDemandResponse, PrintOnDemandRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/printout-on-demand`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: PrintOnDemandRequestSchema,
        responseSchema: PrintOnDemandResponseSchema,
      },
    }),
  }),
});

export const {usePostPrintoutOnDemandMutation} = metadaWarehousePrintoutOnDemandApi;
